// Entity API 

import { 
  bookingService, 
  customerService, 
  platformService, 
  calendarService, 
  contentService, 
  settingsService, 
  invoiceService,
  authService 
} from './services/index.js';

// Export entities
export const bookings = bookingService();
export const customers = customerService();
export const platforms = platformService();
export const calendar = calendarService();
export const content = contentService();
export const settings = settingsService();
export const invoices = invoiceService();
export const auth = authService();

// Legacy compatibility - alte Exportnamen
export const Booking = bookingService();
export const Customer = customerService();
export const PlatformInventory = platformService();
export const BlockedDate = calendarService();
export const SiteContent = contentService();
export const AppSettings = settingsService();
export const Invoice = invoiceService();
export const User = authService();

// Legacy compatibility
export default {
  get bookings() { return bookingService(); },
  get customers() { return customerService(); },
  get platforms() { return platformService(); },
  get calendar() { return calendarService(); },
  get content() { return contentService(); },
  get settings() { return settingsService(); },
  get invoices() { return invoiceService(); },
  get auth() { return authService(); },
  // Alte Namen
  get Booking() { return bookingService(); },
  get Customer() { return customerService(); },
  get PlatformInventory() { return platformService(); },
  get BlockedDate() { return calendarService(); },
  get SiteContent() { return contentService(); },
  get AppSettings() { return settingsService(); },
  get Invoice() { return invoiceService(); },
  get User() { return authService(); }
};